import { combineReducers } from 'redux';
import user from "./items/user";

export default combineReducers({
    user
});